"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageFromIssues = exports.getIssueBySeverity = void 0;
const types_1 = require("../types");
const getIssueBySeverity = (issues = []) => {
    const initialValue = {
        [types_1.Severity.Fatal]: [],
        [types_1.Severity.Error]: [],
        [types_1.Severity.Warning]: [],
        [types_1.Severity.Information]: [],
    };
    return issues.reduce((accumulator, issue) => {
        var _a, _b, _c;
        const message = issue.expression ? `${issue.expression}: ${issue.diagnostics || ((_a = issue.details) === null || _a === void 0 ? void 0 : _a.text)}` : (issue.diagnostics || ((_b = issue.details) === null || _b === void 0 ? void 0 : _b.text));
        (_c = accumulator[issue.severity]) === null || _c === void 0 ? void 0 : _c.push(message);
        return accumulator;
    }, initialValue);
};
exports.getIssueBySeverity = getIssueBySeverity;
const messageFromIssues = (issueBySeverity) => {
    return Object.entries(issueBySeverity)
        .filter(([severity, items]) => items.length)
        .map(([severity, items]) => `${severity}:\n- ${items.join("\n- ")}`)
        .join("\n\n");
};
exports.messageFromIssues = messageFromIssues;
//# sourceMappingURL=issues.js.map